import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Navbar from "../Navbar/navbar";
import Footer from "../Footer/footer";
import FooterDoodles from "../Footer/footerDoodles";
import icons from "../../icons.config";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { resetPasswordApi } from "../../Providers/authProvider"; // Import API function

const ResetPassword = () => {
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  // Extract token from URL
  const queryParams = new URLSearchParams(location.search);
  const resetToken = queryParams.get("token");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!newPassword || !confirmPassword) {
      setError("Both fields are required.");
      return;
    }
    if (newPassword !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    setError("");
    setSuccessMessage("");
    setLoading(true);

    try {
      await resetPasswordApi(newPassword, resetToken);
      setSuccessMessage("Password reset successfully. Redirecting to Home...");
      setTimeout(() => {
        navigate("/");
      }, 2000);
      
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Navbar />
      <div className="relative min-h-screen flex items-center justify-center bg-tertiary top-10 overflow-hidden">
        <div className="absolute -right-52 -top-12 lg:-right-32 lg:-top-10 z-40">
          <img src={icons.trendCircles} alt="Doodle Right" className="w-[50%] lg:w-[70%]" />
        </div>
        <div className="hidden lg:block absolute left-8 top-20 z-10">
          <img src={icons.aboutUsFlower} alt="Doodle Left" className="w-[77%]" />
        </div>

        <div className="relative z-10 w-full max-w-md bg-tertiary px-8">
          <h2 className="text-center text-3xl font-outfit font-light text-primary1 mb-8">RESET PASSWORD</h2>
          {error && <p className="text-hcolor font-poppins font-light text-center mb-4">{error}</p>}
          {successMessage && <p className="text-green-500 font-poppins font-light text-center mb-4">{successMessage}</p>}

          <form onSubmit={handleSubmit}>
            <div className="relative mb-6">
              <label className="absolute left-2 px-2 bg-tertiary text-primary1 font-outfit text-lg font-medium pointer-events-none transform -translate-y-4 scale-75 top-1">
                NEW PASSWORD
              </label>
              <input
                type={showPassword ? "text" : "password"}
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                placeholder="Enter your new password"
                className="w-full px-4 py-3 border rounded-md bg-tertiary text-primary1 text-md focus:outline-none focus:ring-2 focus:ring-primary1"
              />
              <div
                className="absolute inset-y-0 right-4 flex items-center cursor-pointer"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <FaEye className="text-secondary" /> : <FaEyeSlash className="text-secondary" />}
              </div>
            </div>

            <div className="relative mb-6">
              <label className="absolute left-0 px-2 bg-tertiary text-primary1 font-outfit text-lg font-medium pointer-events-none transform -translate-y-4 scale-75 top-1">
                CONFIRM NEW PASSWORD
              </label>
              <input
                type={showConfirmPassword ? "text" : "password"}
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                placeholder="Confirm your new password"
                className="w-full px-4 py-3 border rounded-md bg-tertiary text-primary1 text-sm focus:outline-none focus:ring-2 focus:ring-primary1"
              />
              <div
                className="absolute inset-y-0 right-4 flex items-center cursor-pointer"
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
              >
                {showConfirmPassword ? <FaEye className="text-secondary" /> : <FaEyeSlash className="text-secondary" />}
              </div>
            </div>

            <button
              type="submit"
              className="w-full bg-hcolor text-tertiary px-6 py-3 text-md font-light hover:bg-tertiary hover:border-2 hover:text-hcolor focus:outline-none focus:ring-2 focus:ring-primary1 disabled:bg-gray-400"
              disabled={loading}
            >
              {loading ? "Processing..." : "SUBMIT"}
            </button>
          </form>
        </div>
      </div>

      <div className="absolute bottom-0 w-full z-0">
        <FooterDoodles />
      </div>
      <Footer />
    </>
  );
};

export default ResetPassword;

